import { createContext, useContext, type ReactNode } from 'react'

// 호스트(shell-web)가 scheduler 화면에 주입하는 동작 — scheduler 패키지는 shell-web 을 import 하지 않는다(D-03 §4.1.5).
// 값이 없으면(Provider 밖·콜백 미제공) 해당 진입점(예: "이력·평가보기 ›" 링크)을 숨긴다.

export interface SchedulerHostContextValue {
  /** 시공파트너 시공이력·평가 슬라이드오버를 연다 */
  openPartnerHistory?: (p: { partnerId: number; partnerName: string }) => void
  /** 자재파트너(거래처) 거래이력·평가 슬라이드오버를 연다 — 값이 없으면 자재파트너 카드의 '이력·평가보기 ›'를 숨긴다 */
  openVendorHistory?: (p: { vendorId: number; vendorName: string }) => void
  /** 셸 나의 할일(/todo)로 이동한다 — 스튜디오 드로어 마운트에서는 드로어를 닫고 이동한다 */
  openTodo?: () => void
  /**
   * 화면 주소로 이동한다 — 신호·할일 처리 버튼의 서버 주소(webPath) 중 간트가 아닌 것(작업보고 확인 · 작업요청 작성 등).
   * 값이 없으면 그런 버튼을 숨긴다. 간트 주소는 화면이 그 자리에서 연다(signalView ganttLinkOf).
   */
  openPath?: (path: string) => void
  /** 인디공사현황 작업요청 작성 화면으로 이동한다 — siteId 를 주면 그 현장을 기본 선택해서 연다. 값이 없으면 [작업요청 작성] 항목을 숨긴다 */
  openWorkOrder?: (p?: { siteId?: number | null }) => void
}

const SchedulerHostContext = createContext<SchedulerHostContextValue | undefined>(undefined)

export function SchedulerHostProvider({ value, children }: { value: SchedulerHostContextValue; children: ReactNode }) {
  return <SchedulerHostContext.Provider value={value}>{children}</SchedulerHostContext.Provider>
}

/** 호스트가 주입한 동작. Provider 밖이면 undefined */
export function useSchedulerHost(): SchedulerHostContextValue | undefined {
  return useContext(SchedulerHostContext)
}
